import React from 'react';
import { Offcanvas, Button } from 'react-bootstrap';
import { FiShoppingBag, FiX, FiPlus, FiMinus, FiEdit2 } from 'react-icons/fi';
import { useSettings } from '../context/SettingsContext';
import styles from './bodywon.module.css';

const CartOffcanvas = ({ show, onHide, cartItems, onRemove, onUpdateQuantity, onViewCart }) => {
  const { formatPrice } = useSettings();
  const totalItems = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <Offcanvas show={show} onHide={onHide} placement="end" className={styles.cartOffcanvas}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className={styles.cartTitle}>
          {totalItems} item{totalItems !== 1 ? 's' : ''}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <div className={styles.cartContentWrapper}>
        <Offcanvas.Body className={styles.cartBody}>
          {cartItems.length === 0 ? (
            <div className={styles.emptyCart}>
              <FiShoppingBag size={80} className={styles.emptyCartIcon} />
              <h4>Your cart is empty</h4>
              <p>Looks like you haven't added anything to your cart yet.</p>
              <Button variant="dark" onClick={onHide} className={styles.continueShoppingBtn}>
                Continue Shopping
              </Button>
            </div>
          ) : (
            <div className={styles.cartItemsList}>
              {cartItems.map(item => (
                <div key={item.cartItemId ?? item.id} className={styles.cartItem}>
                  <div className={styles.cartItemImage}>
                    <img
                      src={item.imageSrc}
                      alt={item.name}
                      width={80}
                      height={100}
                      style={{ objectFit: 'cover', borderRadius: '4px' }}
                    />
                  </div>
                  <div className={styles.cartItemDetails}>
                    <p className={styles.cartItemName}>{item.name}</p>
                    <p className={styles.cartItemColor}>Black <FiEdit2 size={12} /></p>
                    <p className={styles.cartItemPrice}>{formatPrice(item.price)}</p>
                  </div>
                  <div className={styles.cartItemActions}>
                    <button className={styles.removeItemBtn} onClick={() => onRemove(item.cartItemId ?? item.id)}><FiX /></button>
                    <div className={styles.quantitySelector}>
                      {item.isBundleItem ? (
                        <span>1</span>
                      ) : (
                        <>
                          <button onClick={() => onUpdateQuantity(item.cartItemId ?? item.id, item.quantity - 1, item)}><FiMinus /></button>
                          <span>{item.quantity}</span>
                          <button onClick={() => onUpdateQuantity(item.cartItemId ?? item.id, item.quantity + 1, item)}><FiPlus /></button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </Offcanvas.Body>

        {cartItems.length > 0 && (
          <div className={styles.cartFooter}>
            <Button
              variant="outline-dark"
              className={styles.viewCartBtn}
              onClick={onViewCart}
            >
              VIEW CART
            </Button>
          </div>
        )}
      </div>
    </Offcanvas>
  );
};

export default CartOffcanvas;
